export default "__VITE_ASSET__C1qbsyc2__"